export default __webpack_public_path__ + "static/media/csvThumbnail.2ab03a1c.svg";